import { render, staticRenderFns } from "./FormStepHeader.vue?vue&type=template&id=b3651fb4&scoped=true"
import script from "./FormStepHeader.vue?vue&type=script&lang=js"
export * from "./FormStepHeader.vue?vue&type=script&lang=js"
import style0 from "./FormStepHeader.vue?vue&type=style&index=0&id=b3651fb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3651fb4",
  null
  
)

export default component.exports